// Müşteri kontağı ekleme/düzenleme modal'ı
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useMutation, useQueryClient } from 'react-query';
import { FiX } from 'react-icons/fi';
import { customerService } from '../../services/customerService';
import toast from 'react-hot-toast';

const CustomerContactModal = ({ customerId, contact, onClose, onSuccess }) => {
  const queryClient = useQueryClient();
  const [isLoading, setIsLoading] = useState(false);
  
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue
  } = useForm();

  // Kontak oluşturma/güncelleme mutation'ı
  const saveContactMutation = useMutation(
    (data) => {
      if (contact) {
        return customerService.updateContact(customerId, contact.id, data);
      } else {
        return customerService.addContact(customerId, data);
      }
    },
    {
      onSuccess: (data) => {
        toast.success(contact ? 'Kontak güncellendi' : 'Kontak eklendi');
        queryClient.invalidateQueries(['customer', customerId]);
        onSuccess();
      },
      onError: (error) => {
        toast.error(error.response?.data?.message || 'İşlem başarısız');
      }
    }
  );

  // Form'u kontak verileriyle doldur
  useEffect(() => {
    if (contact) {
      setValue('contact_fullname', contact.contact_fullname);
      setValue('contact_role', contact.contact_role);
      setValue('contact_email', contact.contact_email);
      setValue('contact_gsm', contact.contact_gsm);
    }
  }, [contact, setValue]);

  // Form gönderimi
  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      await saveContactMutation.mutateAsync(data);
    } catch (error) {
      console.error('Form gönderim hatası:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content max-w-2xl">
        {/* Modal header */}
        <div className="modal-header">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-medium text-white">
              {contact ? 'Kontak Düzenle' : 'Yeni Kontak'}
            </h3>
            <button
              onClick={onClose}
              className="text-white hover:text-gray-300"
            >
              <FiX size={20} />
            </button>
          </div>
        </div>

        {/* Modal body */}
        <form onSubmit={handleSubmit(onSubmit)} className="p-6 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Ad Soyad */}
            <div>
              <label htmlFor="contact_fullname" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Ad Soyad *
              </label>
              <input
                id="contact_fullname"
                type="text"
                {...register('contact_fullname', { required: 'Ad soyad gerekli' })}
                className={`input-field ${errors.contact_fullname ? 'input-error' : ''}`}
                placeholder="Ad soyad girin"
              />
              {errors.contact_fullname && (
                <p className="mt-1 text-sm text-red-600">{errors.contact_fullname.message}</p>
              )}
            </div>

            {/* Rol */}
            <div>
              <label htmlFor="contact_role" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Rol
              </label>
              <input
                id="contact_role"
                type="text"
                {...register('contact_role')}
                className="input-field"
                placeholder="Rol girin (örn: Satış Müdürü)"
              />
            </div>

            {/* Email */}
            <div>
              <label htmlFor="contact_email" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Email
              </label>
              <input
                id="contact_email"
                type="email"
                {...register('contact_email')}
                className="input-field"
                placeholder="Email adresini girin"
              />
            </div>

            {/* Telefon */}
            <div>
              <label htmlFor="contact_gsm" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Telefon
              </label>
              <input
                id="contact_gsm"
                type="tel"
                {...register('contact_gsm')}
                className="input-field"
                placeholder="Telefon numarasını girin"
              />
            </div>
          </div>

          {/* Modal footer */}
          <div className="flex items-center justify-end space-x-3 pt-6 border-t border-gray-200 dark:border-gray-700">
            <button
              type="button"
              onClick={onClose}
              className="btn-secondary"
              disabled={isLoading}
            >
              İptal
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={isLoading}
            >
              {isLoading ? 'Kaydediliyor...' : (contact ? 'Güncelle' : 'Ekle')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CustomerContactModal;
